import { render, staticRenderFns } from "./DataAnalytics.vue?vue&type=template&id=b8e418ac"
import script from "./DataAnalytics.vue?vue&type=script&lang=js"
export * from "./DataAnalytics.vue?vue&type=script&lang=js"
import style0 from "./DataAnalytics.vue?vue&type=style&index=0&id=b8e418ac&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports